import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EnquiryAttachment, ItemAttachment } from 'src/app/shared/models/data/enquiry.model';
import { DomSanitizer, SafeHtml, SafeUrl } from '@angular/platform-browser';
import { Globals } from 'src/app/shared/globals/globals';

@Component({
  selector: 'app-modal-attach',
  templateUrl: './modal-attach.component.html',
  styleUrls: ['./modal-attach.component.scss']
})
export class ModalAttachComponent implements OnInit, OnChanges{
  @Input() isMobile: boolean = false;
  @Input() theme: string = 'silver';
  @Input() enquiryAttachments: EnquiryAttachment[] = new Array();
  @Input() itemAttachments: ItemAttachment[] = new Array();
  @Input() top: number = 0;
  @Output() closeAttachments: EventEmitter<any> = new EventEmitter();

  title: string = "";
  dialogIcon: string = "fal fa-paperclip";
  ext:string = "";
  safeDocumentUrlBlob?: SafeUrl;
  safeDocumentUrlHtml?: SafeHtml;
  documentType: string = "";
  columnsToHide:string[] = ["attachmentsId", "presignedUrl", "enquiryAttachmentId"];
  urloToDownload: string[] = new Array();

  attachments: any[] = new Array();

  constructor(private translate: TranslateService, private sanitizer: DomSanitizer, public globals: Globals){
    this.title = this.translate.instant('enquiryBook.attachment');
  }

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["enquiryAttachments"] && changes["enquiryAttachments"].currentValue.length > 0){
      this.attachments = new Array();
      this.attachments = JSON.parse(JSON.stringify(changes["enquiryAttachments"].currentValue));
      this.setTitleAndIcon();
    }
  
    if (changes && changes["itemAttachments"] && changes["itemAttachments"].currentValue.length > 0){
      this.attachments = new Array();
      this.attachments = JSON.parse(JSON.stringify(changes["itemAttachments"].currentValue));
      this.setTitleAndIcon();
    }

    if (changes && changes["top"]){
      this.top = changes["top"].currentValue;
    }
  }

  setTitleAndIcon(){
/*     this.ext = this.attach.fileName!.substring(this.attach.fileName!.length - 3, this.attach.fileName!.length);
    this.dialogIcon = this.getFileIcoType(this.attach);
    this.title = this.translate.instant('commons.preview') + " " + this.attach.fileName; */
  }

  setDocumentType(){
    switch (this.ext) {
      case 'pdf':
        this.documentType = 'application/pdf';
        break;
      case 'png':
        this.documentType = 'image/png';
        break;
      case 'pptx':
        this.documentType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
        break;
      case 'docx':
        this.documentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        break;
      case 'xlsx':
        this.documentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        break;
      case 'jpg':
        this.documentType = 'image/jpg';
        break;
      case 'jpeg':
        this.documentType = 'image/jpeg';
        break;
      case 'svg':
        this.documentType = 'image/svg+xml';
        break;
      case 'tiff':
        this.documentType = 'image/tiff';
        break;
      case 'tif':
        this.documentType = 'image/tif';
        break;
      case 'html':
        this.documentType = 'text/html';
        break;
      case 'htm':
        this.documentType = 'text/html';
        break;
      case 'txt':
        this.documentType = 'text/plain';
        break;
      case 'mp4':
        this.documentType = 'video/mp4';
        break;
      case 'mp3':
        this.documentType = 'audio/mpeg';
        break;
      case 'wav':
        this.documentType = 'audio/wav';
        break;
      case 'avi':
        this.documentType = 'video/x-msvideo';
        break;
      case 'mov':
        this.documentType = 'video/quicktime';
        break;
      case 'flv':
        this.documentType = 'video/x-flv';
        break;
      case 'odp':
        this.documentType = 'application/vnd.oasis.opendocument.presentation';
        break;
      case 'exe':
        this.documentType = 'application/x-msdownload'; 
        break;
      case 'zip':
        this.documentType = 'application/zip';
        break;
    }
  }

  getFileIcoType(attach: ItemAttachment):string{
    let _ret: string = "fas fa-file";

    if (attach.fileName!.endsWith('.txt'))
      return 'fas fa-file';

    if (attach.fileName!.endsWith('.doc') || attach.fileName!.endsWith('.docx'))
      return 'fas fa-file-word';

    if (attach.fileName!.endsWith('.xls') || attach.fileName!.endsWith('.xlsx'))
      return'fas fa-file-excel';

    if (attach.fileName!.endsWith('.ppt') || attach.fileName!.endsWith('.pptx'))
      return'fas fa-file-powerpoint';

    if (attach.fileName!.endsWith('.pdf'))
      return'fas fa-file-pdf';

    if (attach.fileName!.endsWith('.jpg') || attach.fileName!.endsWith('.jpeg') || attach.fileName!.endsWith('.png') || attach.fileName!.endsWith('.svg') || attach.fileName!.endsWith('.gif')
        || attach.fileName!.endsWith('.tiff'))
        return 'fas fa-file-image';

    if (attach.fileName!.endsWith('.zip') || attach.fileName!.endsWith('.7z'))
      return'fas fa-file-archive';
    
    if (attach.fileName!.endsWith('.mp4') || attach.fileName!.endsWith('.mov'))
      return'fas fa-file-video';

    if (attach.fileName!.endsWith('.mp3') || attach.fileName!.endsWith('.wav'))
      return'fas fa-file-audio';

    return _ret;
  }

  setUrlBlob(){
/*     const blob = new Blob([this.urloToDownload!], { type: this.documentType });
    const fileURL = window.URL.createObjectURL(blob); // + "." + _extension; 
    if (this.documentType.startsWith("application/vnd.")){
      this.safeDocumentUrlHtml =  this.sanitizer.bypassSecurityTrustHtml(fileURL);
    } else {
      this.safeDocumentUrlBlob =  this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
    } */
  }

  /* EVENTS */
  onCloseModalClick(){
    this.closeAttachments.emit('');
  }

  onDownloadAttach(){
    this.urloToDownload.forEach((url, index) => {
      setTimeout(() => {
        const a = document.createElement('a');
        a.href = url;
        a.download = '';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }, index * 500); // set a small delay between each download
    });
  }
  
  rowsSelected(rows: ItemAttachment[]){
    console.log("ROWS SELECTED", rows);
    this.urloToDownload = new Array();
    for (var x=0; x < rows.length; x++){
      this.urloToDownload.push(rows[x].presignedUrl!);
      this.ext = rows[x].fileName!.substring(rows[x].fileName!.length - 3, rows[x].fileName!.length);
    }

    console.log("URL SELECTED", this.urloToDownload);
  }
}
